import { useResourceValue } from '@composables'
import { Settings } from '@config/game.js'
import { userStatsStore } from '@stores'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import {
  USER_COLLECTION_BROWSE_ROUTE,
  USER_GUIDE_BROWSE_ROUTE,
  USER_MOD_BROWSE_ROUTE,
} from '@config/routeNames.js'

export default function (nameId, gameRoute = false) {
  const { getUserStats } = userStatsStore()

  const userStats = getUserStats(nameId, gameRoute)
  const { t } = useI18n()

  const collectionTotal = computed(() => userStats.value?.collection_count || 0)
  const guideTotal = computed(() => userStats.value?.guide_count || 0)
  const modTotal = computed(() => userStats.value?.mod_count || 0)

  const userTotals = computed(() => {
    const totals = [
      {
        stat: modTotal.value,
        text: useResourceValue().ugcName().value,
        icon: 'cog',
      },
    ]

    if (Settings.value.showCollections) {
      totals[0].route = USER_MOD_BROWSE_ROUTE
      totals.push({
        stat: collectionTotal.value || 0,
        text: t('collection', 2),
        icon: 'layer-group',
        route: USER_COLLECTION_BROWSE_ROUTE,
      })
    }

    if (Settings.value.showGuides) {
      totals[0].route = USER_MOD_BROWSE_ROUTE
      totals.push({
        stat: guideTotal.value,
        text: t('guide', 2),
        icon: 'book-open',
        route: USER_GUIDE_BROWSE_ROUTE,
      })
    }

    return totals
  })

  return {
    userTotals,
  }
}
